import React from 'react';
import { Flex, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Study } from 'jf/api';
import { DevExTheme, useDevExTheme } from 'jf/common/themes/DevExTheme';

import { STUDY_STATUS_META } from './StudyStatusTag';

const BUBBLE_SIZE = {
  md: 32,
  sm: 28,
  xs: 24,
};

const isArray = <T,>(arg: T | T[]): arg is T[] => Array.isArray(arg);

type StudyStatusBubbleProps = {
  study: Study | Study[];
  size?: 'xs' | 'sm' | 'md';
  tooltip?: boolean;
  style?: React.CSSProperties;
  className?: string;
};

export const StudyStatusBubble: React.FC<StudyStatusBubbleProps> = ({
  study,
  size = 'md',
  tooltip,
  style,
  className,
}) => {
  const theme = useDevExTheme();

  let color: keyof DevExTheme['color']['tag'] = 'default';
  if (!isArray(study)) {
    color = STUDY_STATUS_META[study.status].color;
  }
  const colors = theme.color.tag[color];

  return (
    <Tooltip
      title={
        tooltip &&
        (isArray(study) ? (
          <div>
            {study.map((study, i) => (
              <div key={i}>{study.name}</div>
            ))}
          </div>
        ) : (
          study.name
        ))
      }
    >
      <Flex
        align="center"
        justify="center"
        style={{
          background: colors.background,
          color: colors.text,
          height: BUBBLE_SIZE[size],
          width: BUBBLE_SIZE[size],
          minWidth: BUBBLE_SIZE[size],
          borderRadius: BUBBLE_SIZE[size],
          fontSize: theme.variable.fontSize[isArray(study) ? 'sm' : size],
          ...style,
        }}
        className={className}
      >
        {isArray(study) ? (
          `+${study.length}`
        ) : (
          <FontAwesomeIcon icon={STUDY_STATUS_META[study.status].icon} />
        )}
      </Flex>
    </Tooltip>
  );
};
